import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import { SelectMulti } from "../MultiSelect/MultiSelect";
import {
  useEditCustomer,
  useGetAreas,
  useGetBrands,
  useGetCategory,
  useGetCities,
  useGetGroupingData,
  useGetMarketer,
} from "../../hooks/useCrm";
import {
  CustomerRanking,
  CustomerType,
  MethodOfIntroduction,
  MethodOfSell,
} from "../../data/crmGeneralData";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import Loading from "../Loadings/LoadingTable";
import { useQueryClient } from "react-query";
const initvalue = {
  FirstName: "h",
  LastName: "",
  Phone: "",
  PhoneTwo: "",
  methodOfIntroduction: "",
  IdIdCities: "",
  KindSeller: "",
  IdMarketer: "",
  Area: "",
  RankingCustomer: "",
  OldPrice: "",
  KindCustomer: "",
  ProbabilityOfPurchase: "0",
  NameCategory: "",
  NameCompany: "",
  BrandCategory: "",
  Description: "",
  IdUserFile: null,
  IdS0alesOpportunities: null,
  BrandCategory: "",
};
export const EditCustomerModal = ({ show, handleClose, userdata }) => {
  const queryclient = useQueryClient();
  const userfile = userdata?.sales_opportunities[0];
  const [form, setForm] = useState(initvalue);
  const [data, setData] = useState();
  useEffect(() => {
    setForm({
      FirstName: userfile?.FirstName,
      LastName: userfile?.LastName,
      Phone: userfile?.Phone,
      PhoneTwo: userfile?.PhoneTwo,
      methodOfIntroduction: userfile?.methodOfIntroduction,
      IdIdCities: userfile?.IdIdCities,
      KindSeller: userfile?.KindSeller,
      IdMarketer: userfile?.IdMarketer,
      Area: userfile?.Area,
      RankingCustomer: userfile?.RankingCustomer,
      OldPrice: userfile?.OldPrice,
      KindCustomer: userfile?.KindCustomer,
      ProbabilityOfPurchase: "0",
      NameCategory: userfile?.NameCategory,
      NameCompany: userfile?.NameCompany,
      BrandCategory: userfile?.BrandCategory,
      Description: userfile?.Description,
      IdUserFile: userfile?.IdUser,
      IdS0alesOpportunities: userfile?.IdS0alesOpportunities,
      BrandCategory: userfile?.BrandCategory,
    });
  }, [userfile]);
  useEffect(() => {
    setData(userdata);
  }, [userdata]);
  const [button] = useState(false);
  const { data: areas } = useGetAreas();
  const { data: cities } = useGetCities();
  const { data: brands } = useGetBrands();
  const { data: cat } = useGetCategory();
  const { data: marketer } = useGetMarketer();
  const { mutateAsync: EditCustomer, isLoading: EditCustomerLoading } =
    useEditCustomer();
  const { data: grouping } = useGetGroupingData();
  const methodOfIntroduction =
    grouping?.data?.groping_new_user_crms[0]?.methodOfIntroduction?.map(
      (item) => {
        return {
          value: item.ContentGroping,
          label: item.ContentGroping,
        };
      }
    );
  const rankingCustomer =
    grouping?.data?.groping_new_user_crms[0]?.RankingCustomer?.map((item) => {
      return {
        value: item.ContentGroping,
        label: item.ContentGroping,
      };
    });
  const kindSeller = grouping?.data?.groping_new_user_crms[0]?.KindSeller?.map(
    (item) => {
      return {
        value: item.ContentGroping,
        label: item.ContentGroping,
      };
    }
  );
  const Brands = brands?.data?.brands;
  const brandsOptions = Brands?.map((brand) => {
    return {
      value: brand.IdBrands,
      label: brand.NameBrands,
    };
  });

  const Areas = areas?.data?.areas;
  const areasOptions = Areas?.map((area) => {
    return {
      value: area.IdAreas,
      label: area.NameAreas,
    };
  });
  const Cities = cities?.data?.ProvincesAndCities;
  const CitiesOptions = Cities?.map((city) => {
    return {
      value: city.IdCities,
      label: city.NameProvinces + "-" + city.NameCities,
    };
  });
  const methodsOfIntroduction = MethodOfIntroduction.map((method) => {
    return {
      value: method.value,
      label: method.label,
    };
  });
  const categories = cat?.data?.categories;
  const categoriesOptions = categories?.map((cat) => {
    return {
      value: cat.NameCategories,
      label: cat.NameCategories,
    };
  });
  const methodsOfSell = MethodOfSell.map((sell) => {
    return {
      value: sell.value,
      label: sell.label,
    };
  });
  const Marketers = marketer?.data?.Marketer;
  const MarketersOptions = Marketers?.map((mark) => {
    return {
      value: mark.IdUser,
      label: mark.FirstName + " " + mark.LastName,
    };
  });
  const customerRanking = CustomerRanking.map((rank) => {
    return {
      value: rank.value,
      label: rank.label,
    };
  });
  const customerType = CustomerType.map((type) => {
    return {
      value: type.value,
      label: type.label,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  const handleEdit = async (EditedData) => {
    await EditCustomer(EditedData);
  };
  const currentarea = areas?.data?.areas.filter(
    (area) => area.IdAreas == form.Area
  );
  return (
    <BootstrapModal
      modaltitle="ویرایش مشخصات مشتری"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="lg"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      {!EditCustomerLoading ? (
        <>
          <div className="row">
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <InputField1
                className={"form-control mx-0"}
                name={"FirstName"}
                label={"نام"}
                type={"text"}
                id={"NameCustomer"}
                placeholder={userfile?.FirstName}
                value={form?.FirstName}
                onChange={handleChange}
              ></InputField1>
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <InputField1
                onChange={handleChange}
                className={"form-control"}
                name={"LastName"}
                label={"نام خانوادگی"}
                type={"text"}
                placeholder={userfile?.LastName}
                value={form?.LastName}
                id={"FamilyNameCustomer"}
              ></InputField1>
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <InputField1
                onChange={handleChange}
                name={"Phone"}
                label={"شماره تماس"}
                type={"text"}
                placeholder={"شماره تماس"}
                id={"NumberCustomer"}
                className={"form-control"}
                value={form?.Phone}
              ></InputField1>
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <InputField1
                onChange={handleChange}
                name={"PhoneTwo"}
                label={"شماره های بیشتر"}
                type={"text"}
                placeholder={
                  form?.PhoneTwo ? form?.PhoneTwo : "شماره بیشتر ندارد"
                }
                id={"PhoneTwoCustomer"}
                className={"form-control"}
                value={form?.PhoneTwo ? form?.PhoneTwo : null}
              ></InputField1>
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SelectMulti
                label={"دسته بندی"}
                res={categoriesOptions}
                onChange={(e) => {
                  setForm({
                    ...form,
                    NameCategory: Array.isArray(e)
                      ? e.map((x) => x.value).join(",")
                      : [],
                  });
                }}
                defaultValue={form?.NameCategory}
              />
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SimpleSelect1
                label={"نحوه آشنایی"}
                res={methodOfIntroduction}
                onChange={(e) => {
                  setForm({
                    ...form,
                    methodOfIntroduction: e.value,
                  });
                }}
                placeholder={form?.methodOfIntroduction}
              />
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SimpleSelect1
                label={"استان شهر"}
                res={CitiesOptions}
                onChange={(e) =>
                  setForm({
                    ...form,
                    IdIdCities: e.value,
                  })
                }
                // value={userfile?.NameCities}
                placeholder={userfile?.NameCities}
              />
            </div>{" "}
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SelectMulti
                label={"برند"}
                res={brandsOptions}
                onChange={(e) =>
                  setForm({
                    ...form,
                    BrandCategory: Array.isArray(e)
                      ? e.map((x) => x.label).join(",")
                      : [],
                  })
                }
                defaultValue={userfile?.BrandCategory}
              />
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SimpleSelect1
                label={"نوع فروش"}
                res={kindSeller}
                onChange={(e) =>
                  setForm({
                    ...form,
                    KindSeller: e.value,
                  })
                }
                placeholder={form?.KindSeller}
              />
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SimpleSelect1
                label={"لیست بازاریابان"}
                res={MarketersOptions}
                onChange={(e) =>
                  setForm({
                    ...form,
                    IdMarketer: e.value,
                  })
                }
                placeholder={
                  data?.MarketerUser[0]?.FirstName +
                  " " +
                  data?.MarketerUser[0]?.LastName
                }
              />
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SimpleSelect1
                label={"منطقه"}
                res={areasOptions}
                onChange={(e) =>
                  setForm({
                    ...form,
                    Area: e.value,
                  })
                }
                placeholder={
                  currentarea ? currentarea[0]?.NameAreas : form.Area
                }
              />
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SimpleSelect1
                label={"رتبه بندی مشتری"}
                res={rankingCustomer}
                onChange={(e) =>
                  setForm({
                    ...form,
                    RankingCustomer: e.value,
                  })
                }
                placeholder={form?.RankingCustomer}
              />
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <InputField1
                onChange={handleChange}
                name={"OldPrice"}
                label={"مانده دوره قبلی"}
                type={"text"}
                placeholder={form?.OldPrice}
                value={form?.OldPrice}
                id={"NumberCustomer"}
                className={"form-control"}
              ></InputField1>
            </div>
            <div className="p-1 form-group col-lg-4 col-md-6 col-12 col-sm-6">
              <SimpleSelect1
                label={"نوع مشتری"}
                res={customerType}
                onChange={(e) =>
                  setForm({
                    ...form,
                    KindCustomer: e.value,
                  })
                }
                placeholder={form?.KindCustomer}
              />
            </div>
            <div className="p-1 w-100">
              <div className="form-group">
                <InputField1
                  onChange={handleChange}
                  name={"Description"}
                  label={"توضیحات بیشتر"}
                  type={"text"}
                  placeholder={"توضیحات"}
                  id={"Description"}
                  className={"form-control"}
                  value={form.Description}
                ></InputField1>
              </div>
            </div>
          </div>
          <div className="w-100">
            <Button
              bgColor="#0d6efd"
              color="#fff"
              onclick={() => {
                handleEdit(form);
                handleClose();
              }}
            >
              ذخیره
            </Button>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </BootstrapModal>
  );
};
